import axios from 'axios';

const url = process.env.REACT_APP_BASE_URL;

export const getReuploadRequest = async (setOpen, setData) => {
  try {
    if(sessionStorage.getItem('UserToken')) {
    await axios
      .get(`${url}/finvesta_user_document_reupload_list`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
        }
      })
      .then((res) => {
        if (res.data !== null) {
          setOpen(true);
          setData(res.data);
          console.log(res.data);
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const postDocumentReupload = async (data, setAlertMessage, setAlertType, handleClick, handleOpenLoader, handleCloseLoader) => {
  console.log(data);
  try {
    handleOpenLoader();
    const uploadedpromise = Object.entries(data).map(([key, value]) => {
      const formdata = new FormData();
      formdata.append('file', value);
      formdata.append('document_name', key);
      const response = axios.post(`${url}/finvesta_user_file_upload/${key}`, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
        }
      });

      return response;
    });
    const res = await Promise.all(uploadedpromise);
    console.log(res);
    const allSuccessful = res.every((response) => response && response.status === 201);

    if (allSuccessful) {
      handleCloseLoader();
      setAlertMessage('Document upload Successful');
      setAlertType('success');
      handleClick();
      setTimeout(() => {
        window.location.href = '/self-agentonboarding/product/dashboard/';
      }, 2000);
    } else {
      handleCloseLoader();
      setAlertMessage('Document upload Partially Successful');
      setAlertType('warning');
      handleClick();
    }
  } catch (error) {
    console.log(error);
    handleCloseLoader();
    setAlertMessage(error.response&&error.response.data.error?error.response.data.error:'Document upload Failed');
    setAlertType('error');
    handleClick();
  }
};
